module.exports = __webpack_public_path__ + "img/35TUTA-AMBRA-U-COLORI-GARZA--SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE15.d2d63031.jpg";